var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable } from 'mobx';
import { runtime } from '../../../../classes/runtime/Runtime';
export class WordTaskMutability {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get wordTaskEvaluate() {
        return this.wordTask.wordTaskEvaluate;
    }
    get m1_whenShouldComplete() {
        if (this.wordTask.taskProgress.isTaskCompleted)
            return false;
        return this.wordTaskEvaluate.isCorrectToCurrentInput || this.wordTaskEvaluate.isWrongToCurrentInput;
    }
    m1_setCompleted() {
        this.wordTaskEvaluate.manifestedMatchSimilarity = this.wordTaskEvaluate.matchSimilarity;
        this.wordTaskEvaluate.manifestedDisproveCertainty = this.wordTaskEvaluate.disproveCertainty;
        this.wordTaskEvaluate.manifestedEvaluationValue = this.wordTask.wordTaskInput.inputValueForEvaluation;
        this.wordTask.taskProgress.dateOfCompletion = runtime.runtimeClock.currentDate;
        if (this.wordTaskEvaluate.isMainifestedWrong) {
            this.wordTask.question.answeringStepMistake.trackMistake();
        }
        if (this.wordTaskEvaluate.isMainifestedCorrect) {
            this.wordTask.question.answeringStepCorrect.trackCorrect();
        }
    }
}
__decorate([
    computed
], WordTaskMutability.prototype, "m1_whenShouldComplete", null);
__decorate([
    action.bound
], WordTaskMutability.prototype, "m1_setCompleted", null);
